import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema type="WebPage" data={{ name: '韩国漫画网 - 韩漫在线免费看', description: '韩漫在线免费看平台，提供最新最全的韩国漫画免费在线阅读服务，支持下拉式免费阅读。' }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotComics />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}